export default function InputError({ message, className = '', ...props }) {
    return message ? (
        <p {...props} className={'mt-0.5 text-xs text-red-500 ' + className}>
            {message}
        </p>
    ) : null;
}
